<template>
  <div class="block">
    <el-button class="back" type="text" @click="back">&lt; 返回印章管理</el-button>

    <div class="title">创建企业印章</div>

    <el-row class="content" :gutter="40">
      <el-col :span="14">
        <div class="img_block">
          <img :src="imgUrl" v-if="formSearch.sealType === 1" />
          <template v-else>
            <el-upload
              class="upload"
              :http-request="uploadFn"
              :before-upload="beforeAvatarUpload"
              :show-file-list="false"
            >
              <template v-if="imgUrl">
                <div class="img_shadow">上传图片</div>
                <img :src="imgUrl" />
              </template>
              <template v-else>
                <el-button type="text">上传图片</el-button>
                <template class="el-upload__tip">支持jpg/jpeg/png/bmp格式图片上传，图片大小在5M以内</template>
              </template>
            </el-upload>
          </template>
        </div>
      </el-col>

      <el-col :span="10">
        <el-form ref="form" :model="formSearch" label-position="top" :rules="rules">
          <el-form-item label="印章名称" prop="alias">
            <el-input
              size="mini"
              v-model="formSearch.alias"
              placeholder="请输入印章名称"
              :disabled="step !== 1"
            ></el-input>
          </el-form-item>

          <el-form-item label="印章来源">
            <el-radio-group v-model="formSearch.sealType" :disabled="step !== 1">
              <el-radio :label="1">模板印章</el-radio>
              <el-radio :label="2">本地上传</el-radio> 
            </el-radio-group>
          </el-form-item>

          <template v-if="formSearch.sealType === 1">
            <el-form-item label="横向文" prop="htext">
              <el-input
                size="mini"
                v-model="formSearch.htext"
                placeholder="请输入横向文"
                :disabled="step !== 1"
              ></el-input>
            </el-form-item>

            <el-form-item label="下弦文" prop="qtext">
              <el-input
                size="mini"
                v-model="formSearch.qtext"
                placeholder="请输入下弦文"
                :disabled="step !== 1"
              ></el-input>
            </el-form-item>

            <el-form-item label="印章样式">
              <div style="display: flex;">
                <div
                  class="img"
                  :class="{'checked': formSearch.type === 'TEMPLATE_ROUND', 'div_disable': step !== 1}"
                  @click="setType(1)"
                >
                  <img src="../../assets/img/my/seal_round.png" alt />
                  <!-- <img :src="url + '/api/act/editor-app/images/seal01.png'" alt /> -->
                </div>
                <div
                  class="img"
                  :class="{'checked': formSearch.type === 'TEMPLATE_OVAL', 'div_disable': step !== 1}"
                  @click="setType(2)"
                >
                  <img src="../../assets/img/my/seal_ellipse.png" alt />
                  <!-- <img :src="url + '/api/act/editor-app/images/seal02.png'" alt /> -->
                </div>
              </div>
            </el-form-item>
          </template>
        </el-form>
      </el-col>
    </el-row>

    <div class="footer">
        <el-button
          type="primary"
          @click="preView"
          :loading="btnLoading"
          v-if="step === 1 && formSearch.sealType === 1"
        >预览</el-button>
        <el-button
          v-if="step === 2"
          type="primary"
          @click="reset"
          :loading="btnLoading"
        >重置</el-button>
        <el-button
          v-if="step === 2"
          type="primary"
          @click="save"
          :loading="btnLoading"
        >暂存</el-button>
        <el-button @click="back">放弃</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'company', // 企业印章
  data () {
    return {
      btnLoading: false,
      success: false,
      step: 1,
      imgUrl: '',
      formSearch: {},
      rules: {
        alias: [
          { required: true, message: '请输入印章名称', trigger: 'blur' },
          { max: 32, message: '最长支持32位字符', trigger: 'blur' }
        ],
        htext: [{ max: 32, message: '最长支持32位字符', trigger: 'blur' }],
        qtext: [{ max: 32, message: '最长支持32位字符', trigger: 'blur' }]
      },
      routeQuery: {},
      url: window.location.origin
    }
  },
  computed: {
        mainTabs: {
            get () { return this.$store.state.mainTabs },
            set (val) { this.$store.commit('updateMainTabs', val) }
        },
        mainTabsActiveName: {
            get () { return this.$store.state.mainTabsActiveName },
            set (val) { this.$store.commit('updateMainTabsActiveName', val) }
        },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.step = 1
      this.imgUrl = ''
      this.success = false
      let data = this.routeQuery.data
      if (data) { // 编辑
        this.formSearch = {
          sealType: data.sealType,
          color: data.color,
          type: data.type,
          central: data.central,
          orgId: data.orgId,
          alias: data.sealName,
          htext: data.htext,
          qtext: data.qtext

        }
        this.imgUrl = data.url
      } else { // 新增
        this.formSearch = {
          sealType: 1,
          color: 'RED',
          type: 'TEMPLATE_ROUND',
          central: 'STAR'
        }
      }
    },
    setType (type) {
      if (this.step === 1) {
        if (type === 1) {
          this.formSearch.type = 'TEMPLATE_ROUND'
          this.formSearch.central = 'STAR'
        } else {
          this.formSearch.type = 'TEMPLATE_OVAL'
          this.formSearch.central = 'NONE'
        }
      }
    },
    beforeAvatarUpload (file) { // 预上传
      const isLt5M = file.size / 1024 / 1024 / 5 < 1
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!')
      }
      return isLt5M
    },
    uploadFn (param) { // 上传文件
      let data = new FormData()
      data.append('file', param.file)
      data.append('name', param.filename)
      this.upload(data, '/sys/esignSeal/uploadSeal').then(res => {
          if (res.data.code === 'C0000') {
            this.$message.success('上传成功')
            this.formSearch.sealId = res.data.result.sealId
            this.formSearch.sealName = this.formSearch.alias
            this.imgUrl = res.data.result.url
            this.step = 2
            param.onSuccess()
          } else {
            throw new Error(res.data.message)
          }
        }).catch((err) => {
          param.onError()
          this.$message.error(err.response ? err.response.data.message : err.message)
        })
    },
    upload(data, url) {
      return this.$http({
        method: 'post',
        url:this.$adornUrl(url),
        timeout: 20000 * 60,
        data: data,
        headers: {
          'Content-Type': 'multipart/form-data', // 关键
        },
      })
    },
    preView () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.btnLoading = true
          this.$post('/sys/esignSeal/previewSeal', this.formSearch)
            .then(({ data }) => {
              if (data.code === 'C0000') {
                this.formSearch.sealName = this.formSearch.alias
                this.formSearch.sealId = data.result.sealId
                this.imgUrl = data.result.url
                this.step = 2
              } else {
                this.$message.error(data.message)
              }
            })
            .catch(err => {
              console.error(err)
              this.$message.error('服务器正忙，请稍后再试')
            })
            .finally(() => {
              this.btnLoading = false
            })
        }
      })
    },
    reset () {
      this.$get('/sys/esignSeal/delBySealId', { sealId: this.formSearch.sealId })
        .then(({ data }) => {
          if (data.code === 'C0000') {
            this.step = 1
            this.imgUrl = ''
            this.formSearch.sealId = ''
          }
        })
    },
    save () {
      this.btnLoading = true
      this.success = false
      this.$post('/sys/esignSeal/add', this.formSearch)
        .then(({ data }) => {
          if (data.code === 'C0000') {
            this.$message.success(data.message)
            this.success = true
            this.back()
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(err => {
          console.error(err)
          this.$message.error('服务器正忙，请稍后再试')
        })
        .finally(() => {
          this.btnLoading = false
        })
    },
    back () {
      if (this.formSearch.sealId && !this.success) {
        this.$get('/sys/esignSeal/delBySealId', { sealId: this.formSearch.sealId })
      }
      if (this.routeQuery.isIframe) {
        this.$router.go(-1)
      } else {
        this.mainTabs = this.mainTabs.filter(item => item.name !== this.menuActiveName) // 删除
        this.$router.push({ path: '/managementList' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.block {
  padding: 25px 40px;
  position: relative;
  background: #fff;

    .footer {
        padding: 20px 0;
        margin: 0;
        margin-top: 40px;       
        text-align: center;
    }
  .back {
    position: absolute;
    top: 20px;
    left: 20px;
    padding: 0;
  }

  .title {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #333;
    line-height: 16px;
  }

  .content {
    margin-top: 20px;
  }

  .img_block {
    height: 234px;
    width: 100%;
    border: 1px solid rgba(238, 238, 238, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    img {
      width: 200px;
    }

    .upload {
      text-align: center;
      line-height: 1;

      button {
        padding: 0;
      }

      .el-upload__tip {
        font-weight: 400;
        color: #999990;
        margin-top: 10px;
        font-size: 20px;
        transform: scale(0.5);
        line-height: 10px;
      }
    }
  }

  .el-radio {
    margin-left: 0;

    & + .el-radio {
      margin-left: 20px;
    }
  }

  .radio {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    width: 60px;
    cursor: pointer;

    & + .radio {
      margin-left: 60px;
    }
  }

  div.img {
    height: 140px;
    width: 140px;
    border: 1px solid rgba(228, 230, 233, 1);
    cursor: pointer;
    align-items: center;
    justify-content: center;
    display: inline-flex;

    & + .img {
      margin-left: 40px;
    }

    img {
      width: 120px;
    }
  }

  div.checked {
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
  }

  .red {
    background: #ea021e;
  }

  .blue {
    background: #0082ff;
  }

  .black {
    background: #333333;
  }

  .white {
    color: #fff;
  }

  .div_disable {
    cursor: not-allowed !important;
  }

  .img_shadow {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 16px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .img_shadow:hover {
    opacity: 1;
  }
}
</style>
